// Helpers shared across pages for unit-aware quantity logic.
// "kg" allows decimal quantities (e.g., 0.1 → 100 g); other units are integer-only.

export const FRACTIONAL_UNITS = new Set(["kg"]);

export function isFractional(unit) {
  return FRACTIONAL_UNITS.has(unit);
}

export function quantityStep(unit) {
  return isFractional(unit) ? 0.1 : 1;
}

export function quantityMin(unit) {
  return isFractional(unit) ? 0.1 : 1;
}

// Default initial quantity is always 1 (= 1 kg, 1 colis, 1 pièce, 1 botte)
export function quantityDefault(unit) {
  return 1;
}

export function normalizeQuantity(unit, value) {
  const n = Number(value);
  if (Number.isNaN(n) || n <= 0) return quantityMin(unit);
  if (isFractional(unit)) {
    return Math.round(n * 10) / 10; // round to 100 g
  }
  return Math.max(1, Math.round(n));
}

export function formatQuantity(unit, value) {
  if (isFractional(unit)) {
    const n = Number(value);
    if (n < 1) return `${Math.round(n * 1000)} g`;
    return `${n.toFixed(n % 1 === 0 ? 0 : 1)} ${unit}`;
  }
  return `${Math.round(value)} ${unit}${value > 1 && unit !== "kg" ? "s" : ""}`.replace("piece", "pièce");
}

export function unitLabel(unit) {
  const map = { kg: "kg", caisse: "caisse", piece: "pièce", "unité": "unité", botte: "botte" };
  return map[unit] || unit;
}
